import React from 'react';
import PropTypes from 'prop-types';
import CircleWithText from "../posts/CircleWithText";

const Footer = ({footerData}) => {
    Footer.propTypes = {
        footerData: PropTypes.shape({
            siminnLogo: PropTypes.string.isRequired,
            contactSection: PropTypes.shape({
                address: PropTypes.string.isRequired,
                kennitala: PropTypes.string.isRequired,
                vsk: PropTypes.string.isRequired,
                phoneNumber: PropTypes.string.isRequired,
                storeOpenLabel: PropTypes.string.isRequired,
                storeClosedLabel: PropTypes.string.isRequired,
            }),
            contentSection: PropTypes.shape({
                columns: PropTypes.arrayOf(
                    PropTypes.shape({
                        title: PropTypes.string.isRequired,
                        linkItems: PropTypes.arrayOf(
                            PropTypes.shape({
                                label: PropTypes.string.isRequired,
                                url: PropTypes.string.isRequired,
                            })
                        ).isRequired,
                    })
                ).isRequired,
            }).isRequired,
            socialSection: PropTypes.shape({
                socialItems: PropTypes.arrayOf(
                    PropTypes.shape({
                        icon: PropTypes.string.isRequired,
                        link: PropTypes.string.isRequired,
                        label: PropTypes.string.isRequired
                    })
                ).isRequired,
            }).isRequired,
            certificationSection: PropTypes.shape({
                items: PropTypes.arrayOf(
                    PropTypes.shape({
                        icon: PropTypes.string.isRequired,
                        link: PropTypes.string.isRequired,
                        label: PropTypes.string.isRequired
                    })
                ).isRequired,
            }).isRequired,
            image: PropTypes.string.isRequired,
        }),
    };

    function getCurrentTime() {
        const now = new Date();
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    }

    function isStoreOpen(currentTime, openingHours) {
        const [openTime, closeTime] = openingHours.split('-');
        const [openHour, openMinute] = openTime.split(':');
        const [closeHour, closeMinute] = closeTime.split(':');
        const [currentHour, currentMinute] = currentTime.split(':');

        // Adjust for weekends
        const dayOfWeek = new Date().getDay();
        if (dayOfWeek === 6 || dayOfWeek === 0) { // Saturday or Sunday
            return false;
        }

        // Compare times
        return (currentHour > openHour || (currentHour === openHour && currentMinute >= openMinute)) &&
            (currentHour < closeHour || (currentHour === closeHour && currentMinute < closeMinute));
    }

    const currentTime = getCurrentTime();
    const openingHours = '09:00-20:00';
    const storeOpen = isStoreOpen(currentTime, openingHours);

    return (
        <footer className="footer">
            <div className="footerinnerwrap">
                <div id="w-node-_8ff24090-6ac4-468e-6f15-d68adae3624f-66d02b84" className="footercolumnstart">
                    <div id="w-node-_8ff24090-6ac4-468e-6f15-d68adae36250-66d02b84" className="footerlogoiconswrapper">
                        <a aria-label="merki Símans" role="img" href="/" className="footerlogowrap w-inline-block">
                            <div className="siminnlogofooter"><img src={footerData.siminnLogo} alt="siminnLogo"/></div>
                        </a>
                        <div className="addresscontent">

                            <div className="footerbottomaddress">
                                <span><strong>{footerData.contactSection.address}</strong></span>
                                <span>{footerData.contactSection.kennitala}</span>
                                <span>{footerData.contactSection.vsk}</span>
                            </div>
                            <div>
                                {storeOpen ?
                                    <CircleWithText circleWithTextData={{circleColor: "#05774E", text: footerData.contactSection.storeOpenLabel}} /> :
                                    <CircleWithText circleWithTextData={{circleColor: "red", text: footerData.contactSection.storeClosedLabel}} />
                                }
                                <a aria-label="550 6000" href={footerData.contactSection.phoneNumber}
                                   className="footersimanr">{footerData.contactSection.phoneNumber}</a>

                            </div>
                        </div>
                    </div>
                </div>
                {footerData.contentSection.columns.map((element, index) => (
                    <div key={index} className="footer-column">
                        <div className="footercontentblock">
                            <div
                                className="footercontentblockheading">{element.title}
                            </div>
                            {element.linkItems.map((element, index) => (
                                <a key={index} href={element.url} target="_blank" rel="noreferrer" className="footerlink">{element.label}</a>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <div className="footerbottom">
                <div className="socialiconswrapper">
                    <div className="socialicons">
                        {footerData.socialSection.socialItems.map((element, index) => (
                            <a key={index} rel="noreferrer" aria-label={element.label} href={element.link} target="_blank"
                               className="footer-icons w-inline-block">
                                <div className="socialiconembed w-embed">
                                    <img src={element.icon} alt={element.label}/>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
                <div className="footervottunlogowrap desktop">
                    {footerData.certificationSection.items.map((element, index) => (
                        <a key={index} href={element.link} target="_blank" rel="noreferrer"
                           className={"vottunlinkblock w-inline-block " + (element.label === "ISO" ? 'iso' : '')}>
                            <div className="festa w-embed">
                                <img src={element.icon} alt={element.label} className={element.label === "ISO" ? 'iso' : ''}/>
                            </div>
                        </a>
                    ))}

                </div>
            </div>
        </footer>
    );
};

export default Footer;